/**
 * openProductUrl.ts
 *
 * Opens a product URL in the native shopping app (Amazon, Coupang) on
 * Android/iOS when the app is installed, falling back to the system browser.
 * On web, uses standard window.open().
 *
 * Uses the custom AppOpener Capacitor plugin registered in MainActivity.
 */
import { Capacitor, registerPlugin } from '@capacitor/core';

interface AppOpenerPlugin {
  openUrl(options: { url: string }): Promise<void>;
}

const AppOpener = registerPlugin<AppOpenerPlugin>('AppOpener');

/**
 * Open a product URL. On native Android, tries the shopping app first
 * (Amazon Shopping, Coupang) via AppOpener plugin. On web or if the
 * plugin call fails, falls back to window.open().
 */
export function openProductUrl(url: string): void {
  if (Capacitor.isNativePlatform()) {
    AppOpener.openUrl({ url }).catch(() => {
      // Plugin unavailable or failed — fall back to browser
      window.open(url, '_blank', 'noopener,noreferrer');
    });
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
